/*
===============================================================================
    File        =   ikimy-website-app/src/pages/Contact/Contact.js
    Client      =   Rhealize
    Project     =   Ikimy Platform
    Purpose     =   Contact modal 
                    
===============================================================================
    Revision History
        -----------------------------------------------------------------------
        Version Date        Author              Comments
        -----------------------------------------------------------------------
        1.0     2025.02.28  Daniel Rashidian    Initial Creation
        -----------------------------------------------------------------------
===============================================================================
*/

import "./Contact.css";
import { Flex, Text, Button, Image } from "@aws-amplify/ui-react";
import IkimyLogo from "../../assets/images/home/IkimyLogo.png"

const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL;

const Contact = ({
    setContactModalVisible
}) => {

    return (
        <div className="contact-modal">
            <div className="contact-modal-backdrop"></div>
            <Flex
                width="100%"
                maxWidth="755px"
                padding="48px 48px"
                direction="column"
                alignItems="center"
                justifyContent="center"
                gap="10px"
                style={{
                    borderRadius: "6px 6px 0px 0px",
                    border: "1px solid var(--Lines-Divider, #E5E7EB)",
                    background: "var(--Background-White, #FFF)",
                    boxShadow: "0px 4px 25px 0px rgba(51, 51, 51, 0.05)"
                }}
            >
                <Flex
                    direction="column"
                    alignItems="center"
                    gap="24px"
                >
                    <Image
                        width="95.164px"
                        height="43px"
                        display="block"
                        gap="unset"
                        alignItems="unset"
                        justifyContent="unset"
                        shrink="0"
                        position="relative"
                        padding="0px 0px 0px 0px"
                        objectFit="cover"
                        src={IkimyLogo}
                    ></Image>
                </Flex>
                <Flex
                    direction="column"
                    alignItems="center"
                    gap="16.421px"
                >
                    <Text
                        color="#222"
                        fontFamily="Inter"
                        fontSize="32.842px"
                        fontStyle="normal"
                        fontWeight="700"
                        lineHeight="normal"
                        children="Contact Us"
                    ></Text>
                    <Text
                        color="var(--colors-font-tertiary, #5C6670)"
                        fontFamily="Inter"
                        fontSize="19.158px"
                        fontStyle="normal"
                        fontWeight="400"
                        lineHeight="150%"
                        children={`Please contact us at ${SUPPORT_EMAIL} for support`}
                    ></Text>
                </Flex>
                <Flex
                    justifyContent="center"
                    alignItems="flex-start"
                    gap="24px"
                >
                    <Button
                        variation="secondary"
                        children="Close"
                        onClick={(event) => {
                            setContactModalVisible(false);
                        }}
                    ></Button>
                </Flex>
            </Flex>
        </div>
    )
};

export default Contact;